import { GlobalSettings } from "../core/settings/globalsettings";

export class WindowSizeHelper {
	public static calcWindowHeight = () => {
		let heightAsPx = $("body > main").css("height");
		return (parseFloat(heightAsPx) || 400) - (GlobalSettings.panelPadding * 2);
	}

	public static calcSize = (percentage: number, grids: number = 3) => {
		let panelHeadingSize = 32;
		let windowHeight = WindowSizeHelper.calcWindowHeight();
		let gutterSizes = (grids - 1) * GlobalSettings.gutterHeight;
		if (windowHeight <= gutterSizes) {
			return 0;
		}
		let spaceFor = (windowHeight - gutterSizes) / 100 * percentage;
		let spaceSub = panelHeadingSize + (GlobalSettings.panelPadding * 2) + (grids * GlobalSettings.panelSpace);
		if (spaceSub >= spaceFor) {
			return 0;
		}

		let windowHeightFor = spaceFor - spaceSub;
		return windowHeightFor;
	}
}